function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 800",
    style: {
      stroke: "#fff",
      strokeWidth: 3,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 27.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 397",
    transform: "translate(14 14)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 801",
    cx: 4,
    cy: 4,
    r: 4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 802",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(11)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 803",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(22)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 398",
    transform: "translate(14 25)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 801",
    cx: 4,
    cy: 4,
    r: 4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 802",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(11)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 803",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(22)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 399",
    transform: "translate(14 36)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 801",
    cx: 4,
    cy: 4,
    r: 4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 802",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(11)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 803",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(22)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridBtn);
export default __webpack_public_path__ + "static/media/GridBTN.288c64dbe8dc392952c7cc41417694fc.svg";
export { ForwardRef as ReactComponent };